import { useState } from 'react';
import Spinner from 'src/utils/Loader/spinner';
import GeneratedPostPendingApprovalGrid from './generated-post-pending-approval-grid.component';

const GeneratedPostPendingApproval = ({ pendingApprovalPosts, handleReCallPendingApprovalPost, sortBy, sortOrder }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleReFetch = (sortByField = '', order = '') => {
    setIsLoading(true);
    handleReCallPendingApprovalPost(sortByField, order);
    setIsLoading(false);
  };
  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <GeneratedPostPendingApprovalGrid
          pendingApprovalList={pendingApprovalPosts}
          orderBy={sortBy}
          order={sortOrder}
          handleReCallPendingApprovalPost={handleReFetch}
        />
      )}
    </>
  );
};
export default GeneratedPostPendingApproval;
